(function($) {
    var hashTable = new Hashtable();
    var count = 0;
    var doingExpand = true;
    var sourceElement;
    
    var updateCountMessage = function() {
    	var msg = doingExpand ? expandedCountMessage : collapsedCountMessage;
    	$('#expandedMessage').text(formatMessage(msg, [ count ]));
    };
    
    var _displayDialog = function(expanding, source) {
    	doingExpand = expanding;
    	sourceElement = source;
    	count = 0;

    	$('#expandDialog').dialog({
    		modal: true,
            width: 300,
            maxWidth: '90%',
            fluid: true,
            draggable : false,
            resizable : false,
            title : doingExpand ? expandTitle : collapseTitle,
            classes: {'ui-dialog': 'cpwr-ui-dialog'},
            buttons : {
                "STOP" : {
                    text : stopButtonText,
                    "class" : 'close-button',
                    click : function() {
                    	hashTable.each(function(key, value) {
                    		// value is an instance of nestedTable
                    		value.stopExpanding();
                    	});
                    	hashTable.clear();
   	            		$.animateCloseDialog('#expandDialog', sourceElement, true, 240);
                    }
                }
            },
            open: function() {
            	updateCountMessage();
           		$.animateOpenDialog('#expandDialog', sourceElement, false, 240);
            },
            close: function() {
            }
        });
    };
    
    var _closeDialog = function() {
    	$.animateCloseDialog('#expandDialog', sourceElement, true, 200);
    };
    
    $.extend({
    	
    	// expanding is true when expanding nodes, else false. Used to determine dialog title and
    	// message to display.
        displayExpandDialog : function(expanding, id, nestedTable, source) {
        	
        	// Is this the first caller? If so, more work to do
        	if (hashTable.isEmpty()) {
        		_displayDialog(expanding, source);
        	}
        	hashTable.put(id, nestedTable);
        },
        
        removeExpandDialog : function(id) {
        	// Remove nestedTable from hashTable. If last out of the pool
        	// we can close the dialog
        	hashTable.remove(id);
        	if (hashTable.isEmpty()) {
        		_closeDialog();
        	}
        },
        
        incrementExpandCount : function() {
        	count = count + 1;
        	updateCountMessage();
        }
    });
    
}) (jQuery);
